export default function formatUTCDate(date: string | unknown, dateStringLength: number = 19): string {
  if (typeof date !== 'string' || date === 'null') {
    return ''
  }

  const finalDate = new Date(date + 'UTC')
  return finalDate.toISOString().slice(0, dateStringLength)
}
